import { addToGroup, removeFromGroup } from "store/actions";
import { ID } from "store/id";
import { default as store, GroupsOperationData } from "store/store";
export class AddArrow {
    constructor(arrows) {
        this.arrows = arrows;
        this.groupInformation = new GroupsOperationData();
        for (const arrow of arrows) {
            if (arrow.parentGroup) {
                this.groupInformation.add(arrow.parentGroup, arrow.id);
            }
        }
    }
    execute() {
        if (this.groupInformation.hasData()) {
            store.dispatch(addToGroup(this.groupInformation));
        }
        store.dispatchFn("AddArrow", addMutator(this.arrows));
    }
    undo() {
        store.dispatchFn("RemoveArrow", removeMutator(this.arrows.map(a => a.id)));
        if (this.groupInformation.hasData()) {
            store.dispatch(removeFromGroup(this.groupInformation));
        }
    }
}
export class DeleteArrows {
    constructor(arrowData) {
        this.arrowData = arrowData;
        this.groupInformation = new GroupsOperationData();
        for (const arrow of arrowData) {
            if (arrow.parentGroup) {
                this.groupInformation.add(arrow.parentGroup, arrow.id);
            }
        }
    }
    execute() {
        store.dispatchFn("DeleteArrow", removeMutator(this.arrowData.map(a => a.id)));
        if (this.groupInformation.hasData()) {
            store.dispatch(removeFromGroup(this.groupInformation));
        }
    }
    undo() {
        // Add group information first
        if (this.groupInformation.hasData()) {
            store.dispatch(addToGroup(this.groupInformation));
        }
        store.dispatchFn("Undo-DeleteArrow", addMutator(this.arrowData));
    }
}
/** Generic method to update Arrow Data. Should replace all the UpdateArrowX commands. */
export class UpdateArrowProperties {
    constructor(values) {
        this.valuesMap = {};
        this.previousValuesMap = {};
        for (const value of values) {
            this.valuesMap[value.id.id] = value.value;
            this.previousValuesMap[value.id.id] = value.previousValue;
        }
    }
    execute() {
        store.dispatchFn("UpdateArrowProperties", store => mutateArrowWithPartial(store, this.valuesMap));
    }
    undo() {
        store.dispatchFn("UpdateArrowProperties", store => mutateArrowWithPartial(store, this.previousValuesMap));
    }
}
// Mutator methods that modify the store.
function addMutator(data) {
    return (state) => {
        var newState = Object.assign({}, state);
        newState.arrows.push(...data);
        return newState;
    };
}
function removeMutator(ids) {
    return (state) => {
        var newState = Object.assign({}, state);
        newState.arrows = state.arrows.filter(ID.notMatching(ids));
        return newState;
    };
}
const mutateArrowWithPartial = (store, mutations) => (Object.assign(Object.assign({}, store), { arrows: store.arrows.map(a => mutations[a.id.id] !== undefined ? Object.assign(Object.assign({}, a), mutations[a.id.id]) : a) }));
export const addArrowMutator = addMutator;
